import { DataType } from '../../template/models';

export interface Order {
  id: string;
  templateId: string;
  orderName: string;
  orderCode: string;
  orderValue: number;
  customerName: string;
  status: OrderStatus;
  assignedName: string;
  assignedUserId: number;
  createdAt: Date;
}

export enum OrderStatus {
  Created = 1,
  InProgress = 2,
  Completed = 3,
  Cancelled = 4,
  OnHold = 5,
  AwaitingApproval = 6,
  Approved = 7,
  Rejected = 8,
  Archived = 9,
}

export interface OrderPayload {
  orderName: string;
  orderCode: string;
  customerId: string;
  templateId: number;
  orderValue: number;
  assignedUserId: string;
  templateFields: TemplateFieldValue[];
  images: string[];
}

export interface OrderEditPayload extends OrderPayload {
  orderId: number;
  /** RowVersion the client last saw - round-tripped so the backend can detect a stale edit. */
  rowVersion?: string | null;
}

export interface OrderForm {
  templateId: number;
  customerId: number;
  orderValue: number;
  templateFields: TemplateFieldValue[];
}

export interface TemplateFieldValue {
  fieldId: number;
  dataType: DataType;
  value: string | number | boolean | Date;
}

export interface OrderFieldValue {
  dataType: DataType;
  fieldId: number;
  name: string;
  value: string;
}

export interface OrderAuditLog {
  timestamp: Date;
  action: string;
  description: string;
  userName: string;
}

export interface TimelineEvent extends OrderAuditLog {
  icon: string;
  color: string;
}

export interface OrderDetail {
  id: number;
  code: string;
  name: string;
  status: OrderStatus;
  value: number;
  customerName: string;
  customerId: number;
  templateName: string;
  templateId: number;
  assignedToName: string;
  assignedToId: number;
  fieldValues: OrderFieldValue[];
  auditHistory: OrderAuditLog[];
  validations: OrderValidation[];
  comments: OrderComment[];
  images: OrderImage[];
  dependencies: OrderDependency[];
  rowVersion?: string | null;
}

export interface OrderValidation {
  comments: string;
  isApproved: boolean;
  validatedBy: number;
  validatedAt: Date;
}

export interface OrderComment {
  id: number;
  author: string;
  text: string;
  timestamp: Date;
}

export interface OrderImage {
  storedName: string;
  displayName: string;
  url: string;
}

export enum OrderRelationType {
  Predecessor = 1,
  Successor = 2,
}

export interface OrderDependency {
  id: number;
  relatedOrderId: number;
  relatedOrderCode: string;
  relatedOrderName: string;
  relationType: OrderRelationType;
}

export interface AddOrderDependencyPayload {
  targetOrderId: number;
  relationType: OrderRelationType;
}
